import { render, staticRenderFns } from "./CreateIndustryOrganization.vue?vue&type=template&id=d5068900"
import script from "./CreateIndustryOrganization.vue?vue&type=script&lang=ts"
export * from "./CreateIndustryOrganization.vue?vue&type=script&lang=ts"
import style0 from "./CreateIndustryOrganization.vue?vue&type=style&index=0&id=d5068900&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.17_css-loader@7.1.2_@rspack+core@1.4.10_@swc+h_d8efeecc32fffa35b7f76004ea8d599d/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports